"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EFinanceDurableGroupsTrads = void 0;
exports.EFinanceDurableGroupsTrads = {
    familierInvestissementResponsable: "Êtes-vous familier du terme « investissement responsable » ?",
    importanceEngagementsEnvironnementaux: "Donnez-vous de l'importance aux engagements environnementaux pris par la société dans laquelle vous investissez ?",
    partInvestissementsDurables: "Quelle part de vos investissements souhaitez-vous allouer à des actifs qualifiés d'investissements durables ?",
    durabiliteCriterePrimordial: "Dans le cadre de vos investissements, la durabilité est-elle le critère primordial ?",
    preferenceDurabilite: "Si oui, avez-vous des préférences en matière de durabilité sur l'un ou plusieurs des aspects de durabilité suivants ? Veuillez cocher les cases qui correspondent à votre/vos préférence(s)",
};
